<template>
    <div class="" :class="{hidden: !(loading && !showPopUp)}">
        <loading></loading>
    </div>
    <div :class="{hidden: loading && !showPopUp}" >
        <div class="style-body mb-6">
            How do I find my <router-link :to="{ name: 'findMachineID' }" class="text-red hover:text-red-hover">Machine ID</router-link> or
            <router-link :to="{ name: 'findSerial' }" class="text-red hover:text-red-hover">Serial Number</router-link> ?
        </div>

        <form action="" class="form form--floating-label md:w-96" @submit.prevent="formSubmit()" ref='form' >
            <div class="input-container input-container--floating relative h-12 mb-5 "
                 :class="{empty: !formData.machineID, error: submittedOnce && errors.machineID}">
                <input
                        id="contact-name"
                        type="text"
                        v-model="formData.machineID"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue bg-white"
                />
                <label for="contact-name" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                    Machine ID
                </label>
            </div>

            <div class="input-container input-container--floating relative h-12 mb-5 "
                 :class="{empty: !formData.partialSerial, error: submittedOnce && errors.partialSerial}">
                <input
                        id="partialSerial"
                        type="text"
                        v-model="formData.partialSerial"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                />
                <label for="partialSerial" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                    Last 6 characters of Serial Number
                </label>
            </div>

            <div v-if="submittedOnce && errors.message && !showPopUp" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
                {{ errors.message }}
            </div>

            <div v-if="onPasscodePenalty" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
                You may try again in 5 minutes
            </div>

            <div class="mt-10 flex items-center ">
                <button type="submit" class="btn ">Find Machine</button>
                <router-link
                        :to="{ name: 'signIn' }"
                        class="ml-4 text-red hover:text-red-hover font-light underline">Go to Login</router-link>
            </div>
        </form>

    </div>

    <passcode-pop-up :machineID="formData.machineID" :serial="formData.serial ? formData.serial : formData.partialSerial" v-if="!onPasscodePenalty"></passcode-pop-up>

</template>

<script charset="utf-8">

import { values, join, get, transform } from 'lodash';
import Loading from '../includes/Loading.vue';
import PasscodePopUp from '../includes/PasscodePopUp.vue';
import { parseEquipment } from '../../service/parser'
import Vuex from 'vuex';

export default {
    data() {
        return {
            formData: {
      /*          machineID: "10037",
                partialSerial: "MICHAELWASHERE",*/
                machineID: "",
                partialSerial: "",
                serial: "",
            },
            loading: false,
            submittedOnce: false,
            errors: {
                machineID: 'This field is required',
                partialSerial: 'This field is required',
                message: ''
            }
        }
    },

    props: {
        errorMessage: {
            default: ''
        }
    },

    components: {
        Loading,
        PasscodePopUp,
        //PopUp
    },

    created: function(){
        this.setShowPopUp(false);
        this.clearCurrentItem();
        let data = this.getParams();
        if(data.war_id){
            this.formData.machineID = data.war_id;
        }
        if(data.serial){
            this.formData.partialSerial = data.serial;
        }
        this.resetPasscodeFailCounter();
    },


    watch: {
        errorMessage: {
            handler(){
                this.submittedOnce = true;
                this.errors.message = this.errorMessage;
            }
        },
        formData: {
            handler(newVal){
                this.errors.message = '';
                this.errors.machineID = newVal.machineID ? '' : 'This field is required';
                if(newVal.partialSerial){
                    if(newVal.partialSerial.length < 6){
                        this.errors.partialSerial = 'Serial length must be 6 characters or more';
                    }else{
                        this.errors.partialSerial = '';
                    }
                }else{
                    this.errors.partialSerial   = 'This field is required';
                }
            },
            deep: true
        }
    },

    emits: ["submit-success", "submit"],

    computed: {
        ...Vuex.mapGetters('layout', {
            showPopUp: 'showPopUp'
        }),
        ...Vuex.mapGetters('profile', {
            onPasscodePenalty: 'onPasscodePenalty',
            passcodeFailCounter: 'passcodeFailCounter',
        }),
        remainingAttempts() {
            return 3 - this.passcodeFailCounter;
        },
    },

    methods: {
        ...Vuex.mapMutations('layout', {
            setShowPopUp: 'setShowPopUp'
        }),

        ...Vuex.mapActions('equipments', {
            autoLogin: 'autoLogin',
            clearCurrentItem: 'clearCurrentItem',
        }),

        ...Vuex.mapMutations('profile', {
            increasePasscodeFailCounter: 'increasePasscodeFailCounter',
            resetPasscodeFailCounter: 'resetPasscodeFailCounter',
            loginEquipment: 'loginEquipment',
        }),

        verify(passcode){
            return this.formSubmit(passcode);
        },
        getParams(){
            return transform(this.$route.query, function (result, val, key) {
                result[key.toLowerCase()] = val;
            });
        },
        formSubmit(passcode) {
            if(this.onPasscodePenalty){
                return;
            }
            this.submittedOnce = true;
            this.errors.message = '';

            if (join(values(this.errors), '')) {
                return;
            }

            this.$emit('submit');

            let data = {
                war_id: this.formData.machineID,
                partial_serial: this.formData.partialSerial,
                auth: false,
            };

            if(passcode){
                data.passcode = passcode;
            }

            this.loading = true;
            this.clearCurrentItem();

            return this.autoLogin(data).then(res => {
                if(res.has_passcode){
                    this.formData.serial = res.serial;
                    this.setShowPopUp(true);
                }else{
                    this.loginEquipment(parseEquipment(res));
                    this.$router.push({ path: 'autologin', query: { war_id: data.war_id, serial: data.serial ? data.serial : data.partial_serial }});
                }
            })
            .catch(err => {
                console.log(err);
                this.errors = {
                    message: 'Invalid Data'
                };
            }).finally(() => {
                this.loading = false;
            });
        },
    }
}
</script>
